export default __webpack_public_path__ + "static/media/onboarding1.e18fc910.gif";